import { CALL_API} from '../middleware/api';
import {
    GET_ALL_SKETCH_ORDER_COUNTS_REQUEST,
    GET_ALL_SKETCH_ORDER_COUNTS_SUCCESS,
    GET_ALL_SKETCH_ORDER_COUNTS_FAILURE,
    UPDATE_ALL_SKETCH_ORDER_COUNTS,
} from './actionTypes';
import SketchTechSketchOrderClient from '../lib/apiClients/roofSnapApiClient/sketchTechSketchOrderClient';


export const getAllSketchOrderCounts = () => {
    // No need to figure out if we should get the sketch tech sketch order client or not.
    // We just need to determine the number of sketch orders with the Pending Status.
    const sketchTechSketchOrderClient = new SketchTechSketchOrderClient('v2');
    const request = sketchTechSketchOrderClient.getAllSketchOrderCounts;
    
    return {
        [CALL_API]: {
            types: [
                GET_ALL_SKETCH_ORDER_COUNTS_REQUEST,
                GET_ALL_SKETCH_ORDER_COUNTS_SUCCESS,
                GET_ALL_SKETCH_ORDER_COUNTS_FAILURE,
            ],
            request,
        }
    };
};

export const updateAllSketchOrderCounts = (payload) => {
    return {
        type: 
            UPDATE_ALL_SKETCH_ORDER_COUNTS,
        payload: payload
    }
}